import { render, staticRenderFns } from "./sizing-chart-hurrybox.vue?vue&type=template&id=581cbcc4&scoped=true&"
import script from "./sizing-chart-hurrybox.vue?vue&type=script&lang=js&"
export * from "./sizing-chart-hurrybox.vue?vue&type=script&lang=js&"
import style0 from "./sizing-chart-hurrybox.vue?vue&type=style&index=0&id=581cbcc4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581cbcc4",
  null
  
)

export default component.exports